import { useFirePostOfficeAnalyticsEvents } from '@post-office/analytics';
import { useEffect } from 'react';

import { type StableProvider } from '../../types';

export const RenderTrackerProvider: StableProvider = ({ children }) => {
	const { fireAnalyticsEvent } = useFirePostOfficeAnalyticsEvents();

	useEffect(() => {
		fireAnalyticsEvent({
			eventType: 'track',
			action: 'rendered',
			actionSubject: 'placement',
		});
	}, [fireAnalyticsEvent]);

	return <>{children}</>;
};
